<template>
  <v-list-item :style="icon ? 'margin-left:55px' : ''" :to="route" dense>
    <v-list-item-icon>
      <v-icon v-if="icon">{{ icon }}</v-icon>
    </v-list-item-icon>
    <v-list-item-content>
      <v-list-item-title>
        <v-badge
          v-if="showBadge"
          :inline="true"
          :left="true"
          :value="badgeValue > 0"
          :content="badgeValue"
          class="mt-0"
        >
          <span :class="badgeValue ? 'px-1' : ''">
            {{ translatedLabel | uppercase }}
          </span>
        </v-badge>
        <span v-else>
          {{ translatedLabel | uppercase }}
        </span>
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
  export default {
    name: 'OListItem',
    props: {
      route: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      badgeValue: {
        type: Number,
        default: 0,
      },
      // Reserve the badge layout for this item. The badge itself is only visible when badgeValue > 0,
      // but its wrapper stays in the DOM so the label keeps the same offset as the other badged items.
      showBadge: {
        type: Boolean,
        default: false,
      },
      icon: {
        type: String,
        default: '',
      },
    },
    computed: {
      translatedLabel() {
        if (!this.$te(this.label)) {
          return this.label
        }
        return this.$t(this.label)
      },
    },
  }
</script>
